import { Box, Stack } from '@mui/material';
import type { ReactNode } from 'react';
import type { SectionElement } from '../../format/form-definition';
import { SectionHeading } from '../../rendering/FormElements';
import { UNTITLED } from './CanvasField';

export const CanvasSection = ({ section, children }: { section: SectionElement; children: ReactNode }) => {
  const untitled = section.title.trim() === '';
  return (
    <Stack useFlexGap spacing={3}>
      <Box sx={{ pointerEvents: 'none', ...(untitled && { '& h2': { color: 'text.disabled' } }) }}>
        <SectionHeading title={untitled ? UNTITLED.section : section.title} description={section.description} />
      </Box>
      {children}
    </Stack>
  );
};
